import * as React from "react";
import { Link, Outlet } from "react-router-dom";
import Container from "react-bootstrap/Container";

import { AuthContext } from "../context";
import Navbar from "./Navbar";

import "../styles/layout.css";

const Layout = () => {
  const { fetch } = React.useContext(AuthContext);

  return (
    <>
      <header className="d-flex align-items-center justify-content-center flex-column">
        <div className="tagline d-none d-md-block">{"Snigdha & Sushain"}</div>
        <Navbar />
      </header>
      <main>
        <Container className="py-3 py-md-4" fluid>
          <Outlet />
        </Container>
      </main>
      {fetch && (
        <footer className="py-2 mt-auto d-print-none">
          <Container fluid>
            <Link className="text-light text-decoration-none" to="/logout">
              Logout
            </Link>
          </Container>
        </footer>
      )}
    </>
  );
};

export default Layout;
